import { roundNumber, toBtc } from '@/utils/amount.utils';

import type { OverviewMetrics } from '../types.validator';

/** Normalize the current response without importing historical chart data. */
export function formatStatsVolume(data: OverviewMetrics) {
  return {
    ...data,
    btc_volume: toBtc(data.btc_volume),
    btc_locked: toBtc(data.btc_locked),
    unit_volume: roundNumber(data.unit_volume / 100, 2),
    unit_borrowed: roundNumber(data.unit_borrowed / 100, 2),
  };
}
